import type { WorkflowGraph } from './types';
import { DEFAULT_GRAPHS } from './defaults';

// Rows written by the pre-studio DIY canvas stored nodes in a different shape
// (top-level x/y/type + outputsTo/inputsFrom adjacency, no `position`, no
// `data.kind`). The studio canvas renders React Flow nodes and would crash on
// those rows. All such data is demo seed (the old UI only moved cards by ←/→
// buttons on the built-in presets), so if ANY loaded graph has a legacy node
// we discard the whole collection and reseed with the studio defaults. New
// graphs saved by the studio always pass `isStudioNode`.
export function migrateLegacyGraphs(rows: unknown): WorkflowGraph[] {
  if (!Array.isArray(rows) || rows.length === 0) return DEFAULT_GRAPHS;
  const graphs = rows as WorkflowGraph[];
  const stale = graphs.some(
    (g) => !Array.isArray(g.nodes) || g.nodes.some((node) => !isStudioNode(node)),
  );
  return stale ? DEFAULT_GRAPHS : graphs;
}

function isStudioNode(node: unknown): boolean {
  if (!node || typeof node !== 'object') return false;
  const n = node as Record<string, unknown>;
  if (!('position' in n) || !('data' in n)) return false;
  const data = n.data;
  return !!data && typeof data === 'object' && 'kind' in (data as Record<string, unknown>);
}
